import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import "./veodordetails.css";
import styles from "./bankContactDetail.module.css";
import { ToastContainer, toast } from "react-toastify";
import Multiselect from "multiselect-react-dropdown";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  TextInputField,
  TextInput,
  Select,
  option,
  FilePicker,
} from "evergreen-ui";
import ButtonSolidLg from "../Buttons/ButtonLarge/ButtonSolidLg";
import BankDetails from "../Profile/ProfileTab/BankDetails";
import { loadData } from "../../Utils/localStorage";
import {
  validateEmail,
  validateOnlyNumbers,
  validatePhoneNumber,
} from "../../Utils/Validation";
import { IMAGE_PATH, PRODUCT } from "../../Utils/variables";
const VendorDetails = () => {
  const regexVendorName = /^[a-zA-Z0-9\- ]*$/;
  const [validFiles, setvalidFiles] = useState([
    "image/jpg",
    "image/jpeg",
    "image/png",
  ]);
  const [validFilesPdf, setvalidFilesPdf] = useState([
    "application/pdf",
    "image/jpg",
    "image/jpeg",
    "image/png",
  ]);
  const [isvisible, setIsVisible] = useState(false);
  const [allFiles, setallFiles] = useState([
    {
      unique: "tradeLicense",
      path: "",
      url: "",
      name: "",
      file_size: "",
      file_type: "",
    },
    {
      unique: "taxReg",
      path: "",
      url: "",
      name: "",
      file_size: "",
      file_type: "",
    },
    {
      unique: "vendorLogo",
      path: "",
      url: "",
      name: "",
      file_size: "",
      file_type: "",
    },
  ]);

  //test--------------------------
  const tradeLicense1 = useRef(null);

  //---------------------------
  const { isLogin, vendorId } = useSelector((state) => state.auth);

  const [productSelectedData, setproductSelectedData] = useState([]);
  const navigate = useNavigate();
  const [productType, setproductType] = useState([]);
  const [controlBankSwitch, setcontrolBankSwitch] = useState(false);
  const [checkChecked, setcheckChecked] = useState(true);
  const [vendorDetails, setVendorDetails] = useState({
    tradeLicenseNumber: "",
    tradeLicenseIssueDate: "",
    tradeLicenseExpiryDate: "",
    vendorCompanyName: "",
    country: "ARE",
    typeofProduct: "",
    taxRegistrationNumber: "",
    tradeLicense: "",
    taxRegistrationCertificate: "",
    vendorLogo: "",
  });

  const [bankDetails, setBankDetails] = useState({
    bankName: "",
    bankAccountNumber: "",
    IbanNumber: "",
    swiftCode: "",
    personName: "",
    email: "",
    personNumber: "",
  });
  const [countryCode, setCountryCode] = useState("");
  const SubmitVendor = (e) => {
    if (vendorDetails.tradeLicenseNumber == "") {
      toast.error("Trade License Number field is required");
    }
    else if (
      allFiles.filter((e) => e.unique === "tradeLicense")[0].url == ""
    ) {
      toast.error("please upload Trade Licence ");
    } else if (
      allFiles.filter((e) => e.unique == "tradeLicense")[0].url !== "" &&
      !validFilesPdf.includes(
        allFiles.filter((e) => e.unique == "tradeLicense")[0].file_type
      )
    ) {
      toast.error("please upload supported file type for Trade License");
    }
    else if (
      allFiles.filter((e) => e.unique == "taxReg")[0].url !== "" &&
      !validFilesPdf.includes(
        allFiles.filter((e) => e.unique == "taxReg")[0].file_type
      )
    ) {
      toast.error("please upload supported file type for Tax Registration");
    } else if (
      allFiles.filter((e) => e.unique == "vendorLogo")[0].url !== "" &&
      !validFiles.includes(
        allFiles.filter((e) => e.unique == "vendorLogo")[0].file_type
      )
    ) {
      toast.error("please upload supported file type for Vender Logo");
    } else if (vendorDetails.tradeLicenseIssueDate == "") {
      toast.error("License Issue Date is required");
    } else if (allFiles[0] == "") {
      toast.error("upload is required");
    } else if (vendorDetails.tradeLicenseExpiryDate == "") {
      toast.error("License Expiry Date is required");
    } else if (
      vendorDetails.tradeLicenseExpiryDate <
      moment(new Date()).format("YYYY-MM-DD")
    ) {
      toast.error("Trade License Number is expired");
    } else if (vendorDetails.country == "") {
      toast.error("Country field is required");
    } else if (vendorDetails.vendorCompanyName == "") {
      toast.error("Vendor Name is required");
    } else if (!regexVendorName.test(vendorDetails.vendorCompanyName)) {
      toast.error(
        "Only alphabets, numbers, dashes and space are allowed in Vendor (Company) Name"
      );
    } else if (vendorDetails.vendor_category_id == "") {
      toast.error("Type of Product is required");
    } else if (vendorDetails.vendorCompanyName.length < 4) {
      toast.error(
        "The Vendor Name field must be at least 4 characters in length"
      );
    } else {
      setcontrolBankSwitch(true);
      window.scrollTo(0, 0);
    }
  };

  const handleVendorDetails = (e) => {
    const { name, value } = e.target;
    setVendorDetails({
      ...vendorDetails,
      [name]: value,
    });
  };

  const handleBankDetails = (e) => {
    const { name, value } = e.target;
    setBankDetails({
      ...bankDetails,
      [name]: value,
    });
  };

  const submitBankDetails = async (e) => {
    e.preventDefault();
    if (bankDetails.personName == "") {
      toast.error("Name field is required");
    } else if (bankDetails.email == "") {
      toast.error("Email field is required");
    } else if (!validateEmail(bankDetails.email)) {
      toast.error("Email field must contain a valid email address");
    } else if (
      !validatePhoneNumber(bankDetails.personNumber, vendorDetails.country)
    ) {
      toast.error("Please enter valid Contact Number");
    } else if (!checkChecked) {
      toast.error("Please accept Terms of Service");
    } else {
      setIsVisible(true);
      fetch(process.env.REACT_APP_API_URL + "/api/vendor/store", {
        method: "POST",
        body: JSON.stringify({
          vendor_name: vendorDetails.vendorCompanyName,
          trade_license_number: vendorDetails.tradeLicenseNumber,
          trade_license_issue_date: vendorDetails.tradeLicenseIssueDate,
          trade_license_exp_date: vendorDetails.tradeLicenseExpiryDate,
          company_name: vendorDetails.vendorCompanyName,
          country: vendorDetails.country,
          gstin_number: vendorDetails.taxRegistrationNumber,
          contact_person_name: bankDetails.personName,
          email: bankDetails.email,
          contact_number: bankDetails.personNumber,

          bank_name: bankDetails.bankName,
          bank_account_number: bankDetails.bankAccountNumber,
          iban_number: bankDetails.IbanNumber,
          swift_code: bankDetails.swiftCode,
          // vendor_category_id: "2",
          inserted_by: "2563",
          last_updated_by: "2563",
          last_updated_on: "",
          vendor_category_id: vendorDetails.vendor_category_id,
          documents: allFiles.filter((e) => e.url !== ""),
        }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setIsVisible(false);
          if (res.status == true) {
            toast(`${res.message}`, {
              type: "success",
            });
            localStorage.setItem("success_msg", JSON.stringify(res.message));
            setTimeout(() => {
              navigate("/registrationsuccess");
            }, 1000);
          } else {
            toast(`${res.message}`, {
              type: "error",
            });
          }
        })
        .catch((err) => {
          setIsVisible(false);
          console.log("e", err);
        });
    }
  };
  const getAllCountry = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendor/all_country", {
      method: "POST",
    })
      .then((d) => d.json())
      .then((res) => {
        setCountryCode(res.response);
      })
      .catch((err) => console.log("e", err));
  };

  const OnSelectProduct = (selectedList, selectedItem) => {
    setproductSelectedData([...selectedList]);
    let ids = selectedList.map((a) => a.id);
    let str = ids.join(",");
    setVendorDetails({ ...vendorDetails, ["vendor_category_id"]: str });
  };

  const OnRemoveProduct = (selectedList, removedItem) => {
    setproductSelectedData([...selectedList]);
    let ids = selectedList.map((a) => a.id);
    let str = ids.join(",");
    setVendorDetails({ ...vendorDetails, ["vendor_category_id"]: str });
  };
  const loadProductType = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendor/allcategories", {
      method: "POST",
    })
      .then((d) => d.json())
      .then((res) => {
        setproductType(res.response);

        console.log("pr", res.response);
      })
      .catch((err) => console.log("e", err));
  };
  const customMultiselectData = {
    multiselectContainer: {
      // marginTop: "4px",
      marginBottom: "12px",
      // marginBottom: "16px",
      background: "white",
      width: "300px",
    },
    searchBox: {
      // height: "32px",
      background: "white",
      width: "300px",
      padding: "8px",
      // marginTop: "16px",
    },
    inputField: {
      background: "white",
      width: "240px",
      fontSize: "12px",
      fontWeight: "400",
    },
    chips: {
      background: "#E2F2D9",
      borderRadius: "4px",
      fontSize: "12px",
      // lineHeight: "12px",
      color: "#266700",
    },
    optionContainer: {
      border: "2px solid #ECEBEC",
      overflowY: "scroll",
      height: "100px",
      marginBottom: "10px",
    },
    option: {
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "0px",
    },
    groupHeading: {},
  };
  function fileValidation(fileType) {
    var re = /(\.jpg|\.jpeg|\.bmp|\.gif|\.png)$/i;
    if (!re.exec(fileType)) {
      alert("File extension not supported!");
      return false;
    }
  }
  const handleUpload = (event, unique) => {
    const formData = new FormData();
    formData.append("file[]", event[0]);

    fetch(process.env.REACT_APP_API_URL + "/api/FileUploadmultiple", {
      method: "POST",
      body: formData,
    })
      .then((d) => d.json())
      .then((res) => {
        const response = res[0]
        const narr = [...allFiles].filter((e) => e.unique != unique);
        narr.push({
          unique,
          path: response.path,
          url: response.url,
          name: response.name,
          file_size: response.size,
          file_type: response.type,
        });
        setallFiles(narr);

        // ------------------
      });
  };

  useEffect(() => {
    if (isLogin) {
      navigate("/rfqs");
    }
    let TradeLicenseNumber = loadData("tradeLicenseNumber");
    if (TradeLicenseNumber !== "") {
      setVendorDetails({
        ...vendorDetails,
        tradeLicenseNumber: TradeLicenseNumber,
      });
    }
    getAllCountry();
    loadProductType();
    document.title = PRODUCT + " - Vendor Details";
  }, []);
  return (
    <>
      {controlBankSwitch == false ? (
        <div
          className={"vendorDetailsMainContainer"}
          style={{
            backgroundImage: `url(${IMAGE_PATH}loginLeftBg.svg),
        url(${IMAGE_PATH}vendorDetailsRightBg.svg)`,
          }}
        >
          <div className="superVendorDetailsMainDiv">
            <div className="vendorDetailsHeading">VENDOR DETAILS</div>
            <p className="vendorDetailsHeadingSub">Step 1 of 2</p>
            <div className="vendorDetailsMainDiv">
              <div className="vendorFormSubHeading">Vendor Details</div>
              <div>
                <label htmlFor="">
                  Trade License Number <span> *</span>
                </label>
                <br />
                <TextInput
                  disabled
                  className="mgbottominput"
                  width={300}
                  height={40}
                  name="tradeLicenseNumber"
                  placeholder="xxxxxxxxxx"
                  value={vendorDetails.tradeLicenseNumber}
                  onChange={handleVendorDetails}
                  required
                />
              </div>
              <div className="flexInput">
                <div>
                  <label htmlFor="">
                    Trade License Issue Date <span> *</span>
                  </label>
                  <br />
                  <input
                    className="mgbottominput"
                    type="date"
                    name="tradeLicenseIssueDate"
                    value={vendorDetails.tradeLicenseIssueDate}
                    onChange={handleVendorDetails}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="">
                    Trade License Expiry Date <span> *</span>
                  </label>
                  <br />
                  <input
                    className="mgbottominput"
                    type="date"
                    name="tradeLicenseExpiryDate"
                    value={vendorDetails.tradeLicenseExpiryDate}
                    min={vendorDetails.tradeLicenseIssueDate}
                    onChange={handleVendorDetails}
                    required
                  />
                </div>
              </div>
              <div className="flexInput">
                <div>
                  <label htmlFor="">
                    Vendor (Company) Name <span> *</span>
                  </label>
                  <br />
                  <TextInput
                    className="mgbottominput"
                    width={300}
                    height={40}
                    placeholder="Enter Vendor (Company) Name"
                    name="vendorCompanyName"
                    value={vendorDetails.vendorCompanyName}
                    onChange={handleVendorDetails}
                    required
                  />{" "}
                </div>
                <div>
                  <label htmlFor="">
                    Country <span>*</span>
                  </label>
                  <br />
                  {/* <input type="text" /> */}
                  <select
                    // className="mgbottominput"
                    id="countryInputSelect"
                    width={300}
                    height={40}
                    placeholder="Select"
                    name="country"
                    // value={vendorDetails.country}
                    onChange={handleVendorDetails}
                    required
                  >
                    {countryCode &&
                      countryCode.map((e) =>
                        e.country_id == "ARE" ? (
                          <option value={e.country_id} selected>
                            {e.country_name}
                          </option>
                        ) : (
                          <option value={e.country_id}>{e.country_name}</option>
                        )
                      )}
                  </select>
                  {/* <TextInput
                    className="mgbottominput"
                    width={300}
                    height={40}
                    placeholder="None"
                    name="country"
                    value={vendorDetails.country}
                    onChange={handleVendorDetails}
                    required
                  />{" "} */}
                </div>
              </div>
              <div className="flexInput">
                <div>
                  <label htmlFor="">
                    Type of Product/Service <span> *</span>
                  </label>
                  <br />
                  {productType.length > 0 && (
                    <Multiselect
                      width={300}
                      height={32}
                      options={productType}
                      selectedValues={productSelectedData} // Preselected value to persist in dropdown
                      onSelect={OnSelectProduct}
                      onRemove={OnRemoveProduct}
                      displayValue="name"
                      closeIcon={"close"}
                      style={customMultiselectData}
                    />
                  )}
                </div>
                <div>
                  <label htmlFor="">Tax Registration Number (TRN)</label>
                  <br />
                  <TextInput
                    className="mgbottominput"
                    width={300}
                    height={40}
                    placeholder="Enter Tax Registration Number (TRN)"
                    name="taxRegistrationNumber"
                    value={vendorDetails.taxRegistrationNumber}
                    onChange={handleVendorDetails}
                  />
                </div>
              </div>
              <div className="vendorFormSubHeading vendorFormSubHeadingUpload">
                Upload Files
              </div>
              <div className="flexInput">
                <div>
                  <label htmlFor="">
                    Trade License
                    <span> *</span>
                  </label>
                  <br />
                  <FilePicker
                    multiple={false}
                    width={300}
                    height={40}
                    placeholder="Browse..."
                    name="tradeLicense"
                    id="tradeLicense"
                    accept=".pdf, .jpg, .png, .jpeg"
                    onChange={(e) => handleUpload(e, "tradeLicense")}
                    required
                    ref={tradeLicense1}
                  />
                  <p className="subLabel">Supports PDF, JPG, JPEG, PNG</p>
                </div>
                <div>
                  <label htmlFor="">Tax Registration Certificate</label>
                  <br />
                  <FilePicker
                    multiple={false}
                    width={300}
                    height={40}
                    placeholder="Browse..."
                    name="taxRegistrationCertificate"
                    accept=".pdf, .jpg, .png, .jpeg"
                    onChange={(e) => handleUpload(e, "taxReg")}
                  />
                  <p className="subLabel">Supports PDF, JPG, JPEG, PNG</p>
                </div>
              </div>
              <div>
                <label htmlFor="">Vendor Logo</label>
                <br />
                <FilePicker
                  multiple={false}
                  width={300}
                  height={40}
                  placeholder="Browse..."
                  name="vendorLogo"
                  accept=".jpg, .png, .jpeg"
                  onChange={(e) => handleUpload(e, "vendorLogo")}
                />
                <p className="subLabel">Supports PNG,JPG,JPEG</p>
              </div>
              <div className="vbtn">
                <ButtonSolidLg
                  text={"NEXT STEP"}
                  buttonHandler={SubmitVendor}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={
            PRODUCT === "STRATUM" || PRODUCT === "DANUBE"
              ? styles.mainDivBDST
              : styles.mainDivBD
          }
        >
          <div className={styles.headingDivBD}>
            <div>
              <h1>BANK & CONTACT DETAILS</h1>
              <p>Step 2 of 2</p>
            </div>
          </div>
          <div className={styles.middleDivBD}>
            <div className={styles.formDivBD}>
              <h6 className={styles.subHeadingBD}>Bank Details</h6>
              <div className={styles.flexInputBD}>
                <div>
                  <label htmlFor="">
                    Bank Name
                    {/* <span> *</span> */}
                  </label>
                  <br />
                  <TextInput
                    className={styles.mgbottominput}
                    placeholder="Enter Bank Name"
                    required
                    name="bankName"
                    value={bankDetails.bankName}
                    onChange={handleBankDetails}
                  />
                </div>
                <div>
                  <label htmlFor="">
                    Bank Account Number
                    {/* <span> *</span> */}
                  </label>
                  <br />
                  <TextInput
                    className={styles.mgbottominput}
                    placeholder="Enter Account Number"
                    required
                    name="bankAccountNumber"
                    value={bankDetails.bankAccountNumber}
                    onChange={handleBankDetails}
                  />
                </div>
              </div>

              <div className={styles.flexInputBD}>
                <div>
                  <label htmlFor="">
                    IBAN Number
                    {/* <span> *</span> */}
                  </label>
                  <br />
                  <TextInput
                    className={styles.mgbottominput}
                    placeholder="Enter IBAN Number"
                    required
                    name="IbanNumber"
                    value={bankDetails.IbanNumber}
                    onChange={handleBankDetails}
                  />
                </div>
                <div>
                  <label htmlFor="">
                    SWIFT Code
                    {/* <span>*</span> */}
                  </label>
                  <br />
                  <TextInput
                    className={styles.mgbottominput}
                    placeholder="Enter Swift Code"
                    required
                    name="swiftCode"
                    value={bankDetails.swiftCode}
                    onChange={handleBankDetails}
                  />
                </div>
              </div>
              <h6 className={styles.subHeadingBD}>Primary Contact Details</h6>
              <div className={styles.flexInputBD}>
                <div>
                  <label htmlFor="">
                    Name <span> *</span>
                  </label>
                  <br />
                  <TextInput
                    className={styles.mgbottominput}
                    placeholder="Enter Name"
                    required
                    name="personName"
                    value={bankDetails.personName}
                    onChange={handleBankDetails}
                  />
                </div>
                <div>
                  <label htmlFor="">
                    Email <span> *</span>
                  </label>
                  <br />
                  <TextInput
                    className={styles.mgbottominput}
                    placeholder="Enter Email"
                    required
                    name="email"
                    value={bankDetails.email}
                    onChange={handleBankDetails}
                  />
                </div>
              </div>
              <div>
                <div>
                  <label
                    htmlFor=""
                    className={styles.contactNumberVenDoeDetailsPage}
                  >
                    Contact Number <span> *</span>
                  </label>
                  <br />
                  <div className={styles.contactInputBD}>
                    <Select
                      className={styles.mgbottominputselectbox}
                      width={30}
                      height={40}
                      placeholder="Select"
                      // name="country"
                      // value={bankDetails.country}
                      // onChange={handleBankDetails}
                      name="country"
                      value={vendorDetails.country}
                      onChange={handleVendorDetails}
                      required
                    >
                      {/* <option value="foo" selected>
                        Foo
                      </option>
                      <option value="bar">Bar</option> */}
                      {countryCode &&
                        countryCode.map((option) => (
                          <option value={option.country_id}>
                            {option.country_id}
                          </option>
                        ))}
                    </Select>
                    <TextInput
                      className={styles.mgbottominputcontact}
                      placeholder="Enter Contact Number"
                      required
                      name="personNumber"
                      value={bankDetails.personNumber}
                      onChange={handleBankDetails}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.checkboxBankContactDiv}>
                <input
                  type="checkbox"
                  name="checkValue"
                  checked={checkChecked}
                  onChange={() => setcheckChecked(!checkChecked)}
                />
                <p>
                  By Signing up, I agree to the{" "}
                  <a
                    href={
                      process.env.REACT_APP_ANACITY_URL + "/terms-of-service"
                    }
                    target="_blank"
                  >
                    Terms of Service.
                  </a>
                </p>
              </div>
              <div className="vbtn">
                <ButtonSolidLg
                  showLoader={isvisible}
                  text={"REGISTER"}
                  buttonHandler={submitBankDetails}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer autoClose={5000} />
    </>
  );
};

export default VendorDetails;
